import Vue from 'vue';
import {BootstrapVue} from 'bootstrap-vue';

import '@/config/bootstrap-vue.scss';

Vue.use(BootstrapVue);
